import { isPendingAssistantText } from '@/constants/chat'

/** @typedef {import('./chatThreadTypes.js').ChatMessage} ChatMessage */

/**
 * @param {ChatMessage} assistant
 * @param {(id: string) => void} togglePreambleExpanded
 */
export function getAssistantPreambleToggle(assistant, togglePreambleExpanded) {
  if (isPendingAssistantText(assistant.text) && !assistant.demoStreamActive) return null
  const hasWorkflowSteps =
    Array.isArray(assistant.workflowTrace?.steps) && assistant.workflowTrace.steps.length > 0
  return hasWorkflowSteps ? () => togglePreambleExpanded(assistant.id) : null
}
